export default __webpack_public_path__ + "static/how_it_works_step_4_desktop_tablet-e25e487c0fae56094e609dee0d0b4876.webp";